var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { Grid, Button, List } from "../../components";

var PackageDetails = function PackageDetails(_a) {
  var imageSrc = _a.imageSrc,
      list = _a.list,
      _b = _a.btnText,
      btnText = _b === void 0 ? "Zapytaj o ofertę" : _b,
      _c = _a.isReverse,
      isReverse = _c === void 0 ? false : _c,
      _d = _a.background,
      background = _d === void 0 ? "#00965e" : _d,
      _e = _a.isLight,
      isLight = _e === void 0 ? true : _e,
      anchor = _a.anchor,
      props = __rest(_a, ["imageSrc", "list", "btnText", "isReverse", "background", "isLight", "anchor"]);

  return React.createElement(Grid.Container, __assign({
    id: anchor,
    fluid: true,
    background: background
  }, props), React.createElement(Grid.Container, {
    py: "4rem"
  }, React.createElement(Grid.Row, {
    flexDirection: isReverse ? "row-reverse" : "row"
  }, React.createElement(Grid.Col, {
    lg: {
      size: 5,
      offset: 1
    }
  }, React.createElement("div", {
    style: {
      width: "100%",
      height: "0",
      paddingTop: "100%",
      background: "no-repeat center/cover url(" + imageSrc + ")"
    }
  })), React.createElement(Grid.Col, {
    lg: {
      size: 5,
      offset: 1
    }
  }, React.createElement(List, __assign({}, list, {
    isLight: isLight
  })), React.createElement(Button, {
    style: {
      margin: "0 auto"
    },
    isPrimary: true,
    onClick: function onClick() {
      window.open("/kredytomat/kontakt?product_url=" + window.location.pathname + "&product_name=Konto bankowe dla rolnika w banku BNP", "_blank");
    }
  }, btnText)))));
};

export default PackageDetails;